import React from 'react';
import CreditCheckDeferredPage from './CreditCheckDeferredPage';

const CreditCheckDeferredSection = () => <CreditCheckDeferredPage />;

export default CreditCheckDeferredSection;
